
import React from 'react'
import './index.css'

const  ToneLoader =() => {
 
 
     return (
      
       <div  className='tone-loader'>
             <img src="/assets/Tone_Home/toneloader.webp" alt="toneLoader"  />
        </div>
  )
}

export default ToneLoader;
